module.exports = __webpack_public_path__ + "img/major-prize.7b755e7a.png";